const ES_TOTAL_LIMIT = 10_000

/**
 * Formats a total count for display, accounting for the Elasticsearch
 * default `index.max_result_window` limit of 10,000.
 *
 * When the total equals the ES limit, the actual count is unknown
 * (could be higher), so we display "10,000+" instead.
 */
export const formatTotal = (total: number): string => {
  const formatted = total.toLocaleString()
  if (total >= ES_TOTAL_LIMIT) return `${formatted}+`
  return formatted
}
